<template>
  <div>
    <!-- <BottomSheetModal ref="component" > -->
    <ModalComponent
      ref="modal"
      class="[&_.w-screen>.flex.p-4]:!p-0 [&_.w-screen]:!overflow-hidden [&_.boxComponent]:!bg-transparent [&_.boxComponent]:!w-[100%] [&_.boxComponent]:!h-[100vh] [&_.boxComponent]:!max-w-[100%] [&_.boxComponent]:!max-h-[100vh] [&_.boxComponent]:!rounded-none [&_.boxComponent>div>div]:!p-0"
    >
      <template #header>
        <div></div>
      </template>
      <template #fullContent>
        <div
          class="relative h-screen top-0 left-0 bodyBg flex flex-col title-color"
        >
          <div
            class="absolute pointer-events-none deco w-full h-full rounded-content-md"
          >
            <div
              class="absolute w-full h-full"
              style="
                background: linear-gradient(
                  170.76deg,
                  #37b6e9 6.44%,
                  #4b4ced 99.29%
                );
                clip-path: polygon(80% 1%, 100% 1%, 100% 100%, 0% 100%, 0% 80%);
              "
            ></div>
          </div>
          <div class="h-full overflow-auto">
            <div class="p-6 sticky top-0">
              <div class="abtolute">
                <button class="buttonComponent !p-3" @click="$router.back()">
                  <img
                    src="@/assets/images/all/right-arrow-white.svg"
                    class="h-5 -scale-x-100"
                    alt=""
                  />
                </button>
              </div>
              <div class="py-1"></div>
              <div class="flex flex-col items-center gap-2">
                <div
                  class="rounded-full px-5 py-3 text-xl font-bold"
                  :class="{
                    'bg-[#242c3b] text-white': $ColorTheme.isLight(),
                    'bg-white text-[#242c3b]': $ColorTheme.isDark(),
                  }"
                >
                  {{
                    match.isLive
                      ? $t('matches.details.live')
                      : $t('matches.details.upcoming')
                  }}
                </div>
                <div class="text-2xl font-bold text-center text-primary-300 drop-shadow-xl">
                  {{ match.league }}
                </div>
                <div class="text-xl text-center">
                  {{ match.country }}
                  {{ match.city }}
                </div>
              </div>
              <div class="py-3"></div>
              <div class="grid grid-cols-6 justify-between gap-y-4 px-8">
                <div class="col-span-2">
                  <img
                    class="w-full object-contain object-center"
                    :src="match.team1Picture"
                    alt=""
                  />
                </div>
                <div
                  class="col-span-2 flex items-center justify-center text-4xl font-bold"
                >
                  <div>{{ match.team1Score }} : {{ match.team2Score }}</div>
                </div>
                <div class="col-span-2">
                  <img
                    class="w-full object-contain object-center"
                    :src="match.team2Picture"
                    alt=""
                  />
                </div>
                <div
                  class="col-span-2 text-center font-bold text-xl flex items-center justify-center"
                >
                  <div>
                    {{ match.team1Name }}
                  </div>
                </div>
                <div class="col-span-2"></div>
                <div
                  class="col-span-2 text-center font-bold text-xl flex items-center justify-center"
                >
                  <div>
                    {{ match.team2Name }}
                  </div>
                </div>
              </div>
              <div class="py-3"></div>
              <div class="px-14 h-[20vh]">
                <img
                  src="@/assets/images/king-recharge-assets/stade.svg"
                  alt=" "
                  class="w-full h-full object-contain"
                />
              </div>
            </div>
            <div class="py-4"></div>
            <div class="relative">
              <div class="absolute top-0 left-6 z-[2]">
                <div
                  class="asbolute p-3 bg-red-500 border-[4px] rounded-full -translate-y-1/2"
                >
                  <div
                    class="flex items-center justify-center w-6 h-6 text-2xl"
                  >
                    <div>
                      {{ match.isLive ? match.liveDurationMin : '0' }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="glassBg rounded-t-[30px] p-6 pt-12 pb-[14rem] relative min-h-[40vh]"
              >
                <div class="text-2xl font-bold">
                  {{ $t('matches.details.odds') }}
                </div>
                <div class="py-2"></div>
                <div class="flex flex-col gap-2">
                  <!-- {{ match.odds }} -->
                  <div
                    v-for="(odd, i) in match.odds"
                    class="flex justify-between"
                    :key="i"
                    :class="{ hidden: /inconnu/i.test(odd.description) }"
                  >
                    <div>
                      {{ odd.description }}
                    </div>
                    <div class="font-bold">{{ odd.value }}</div>
                  </div>
                </div>
                <div class="py-4"></div>
                <!-- <div class="text-2xl font-bold">Statistiques</div> -->
                <!-- <div class="py-2"></div> -->
                <div class="flex flex-col gap-2">
                  <div class="flex justify-between">
                    <div class="text-2xl font-bold">Statistiques</div>
                    <div class="font-bold flex text-right gap-4">
                      <div class="w-20 min-w-20 truncate">
                        {{ match.team1Name }}
                      </div>
                      <div class="w-20 min-w-20 truncate">
                        {{ match.team2Name }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="(statistic, i) in match.statistics"
                    class="flex justify-between"
                    :key="i"
                  >
                    <div>
                      {{ statistic.name }}
                    </div>
                    <div class="font-bold flex text-right gap-4">
                      <div class="w-20 min-w-20">
                        {{ statistic.home }}
                      </div>
                      <div class="w-20 min-w-20">
                        {{ statistic.away }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="py-32"></div> -->
              </div>
            </div>
            <div class="absolute bottom-0 w-full">
              <div class="glassBg rounded-t-[30px] overflow-auto p-6 pb-[8vh]">
                <div class="flex items-center justify-center">
                  <button class="buttonComponent small" @click="launchDeposit">
                    {{ $t('matches.details.makeDeposit') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </ModalComponent>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from '@/components/utils/ModalComponent.vue'

export default defineComponent({
  name: 'MatchDetail',
  components: { ModalComponent },
  props: {},
  data() {
    return {
      match: {},
      eventsIds: [],
    }
  },
  mounted() {
    const id = this.$Events.handleEvent('match_detail_required', this.showMatch)
    this.eventsIds.push(id)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    showMatch(match) {
      this.match = match
      this.$refs.modal.show()
      this.$Commons.setThemeColor('#242c3b')
      setTimeout(() => {
        this.$Commons.setThemeColor('#242c3b')
      }, 500)
    },
    launchDeposit() {
      this.$router.back()
      this.$Events.dispatchEvent('deposit_action_requested')
    },
  },
  computed: {},
})
</script>
